import { getUserConfiguration } from 'owa-session-store';
import PontType from 'owa-service/lib/contract/PontType';

export function isGetStartedInListViewClosed(): boolean {
    // Hide get started in listview if pont type value is 0, default value is 1 which means get started
    // is open in listview
    return (
        (PontType.ShowGetStartedPane & getUserConfiguration().UserOptions.NewEnabledPonts) !==
        PontType.ShowGetStartedPane
    );
}
